// src/services/wooService.js
import axios from "axios";

const WOO_BASE_URL = process.env.REACT_APP_WOO_URL;
const WOO_KEY = process.env.REACT_APP_WOO_CONSUMER_KEY;
const WOO_SECRET = process.env.REACT_APP_WOO_CONSUMER_SECRET;

const axiosInstance = axios.create({
  baseURL: `${WOO_BASE_URL}/products`,
  auth: {
    username: WOO_KEY,
    password: WOO_SECRET,
  },
});

/**
 * Fetch WooCommerce products by category and optional parameters.
 * @param {number[]} categoryIds - Array of WooCommerce category IDs.
 * @param {object} extraParams - Additional query parameters (e.g., status, search).
 * @returns {Promise<Array>} List of products.
 */
export const fetchWooProducts = async (categoryIds = [], extraParams = {}) => {
  try {
    const { data } = await axiosInstance.get("", {
      params: {
        per_page: 100,
        category: categoryIds.join(","),
        ...extraParams,
      },
    });
    return data;
  } catch (error) {
    console.error("❌ WooCommerce fetch error:", error.message);
    return [];
  }
};

/**
 * Fetch a single WooCommerce product by slug.
 * @param {string} slug - Product slug.
 * @returns {Promise<Object|null>} Product object or null if not found.
 */
export const fetchWooProductBySlug = async (slug) => {
  try {
    const { data } = await axiosInstance.get("", {
      params: {
        slug,
        status: "publish",
      },
    });
    return data?.[0] || null;
  } catch (error) {
    console.error("❌ WooCommerce fetch (by slug) error:", error.message);
    return null;
  }
};
